import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faChartLine, faChartPie, faCalendarDay, faChevronRight } from '@/fontawesome';
import { JOURNAL_ROUTES } from '@/constants/routes';

const SHORTCUTS = [
  { label: 'Trades', to: JOURNAL_ROUTES.TRADES, icon: faChartLine },
  { label: 'Offene Positionen', to: JOURNAL_ROUTES.POSITIONS, icon: faChartPie },
  { label: 'Gewinn-Kalender', to: JOURNAL_ROUTES.CALENDAR, icon: faCalendarDay },
];

interface JournalCardProps {
  className?: string;
}

export default function JournalCard({ className = '' }: JournalCardProps) {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg p-4 shadow-md border border-gray-200 dark:border-gray-700 h-[320px] flex flex-col ${className}`}>
      <div className="flex items-center space-x-2 mb-4">
        <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/50 rounded-lg flex items-center justify-center">
          <FontAwesomeIcon icon={faBook} className="w-4 h-4 text-blue-600 dark:text-blue-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Trading Journal</h3>
      </div>

      <p className="text-sm text-gray-500 dark:text-gray-400 text-left mb-4">
        Erfasse deine Options-Trades, verfolge Zuteilungen und werte deine Ergebnisse aus.
      </p>

      <div className="flex-1 min-h-0 space-y-2 overflow-y-auto">
        {SHORTCUTS.map((shortcut) => (
          <Link
            key={shortcut.to}
            to={shortcut.to}
            className="flex items-center justify-between px-3 py-2 rounded-lg text-sm text-gray-700 dark:text-gray-200 bg-gray-50 dark:bg-gray-700/50 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
          >
            <span className="flex items-center gap-2">
              <FontAwesomeIcon icon={shortcut.icon} className="w-4 h-4 text-gray-400 dark:text-gray-500" />
              {shortcut.label}
            </span>
            <FontAwesomeIcon icon={faChevronRight} className="w-3 h-3 text-gray-400 dark:text-gray-500" />
          </Link>
        ))}
      </div>

      <Link
        to={JOURNAL_ROUTES.DASHBOARD}
        className="mt-4 inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg transition-colors cursor-pointer"
      >
        <FontAwesomeIcon icon={faBook} className="w-4 h-4" />
        <span>Journal öffnen</span>
      </Link>
    </div>
  );
}
